function div(cost, n) {
  if (typeof n !== "number" || n <= 0) return null;
  return cost / n;
}

export function computeCostMetrics(cost, denominators = {}) {
  const c = Number(cost);
  if (!cost || Number.isNaN(c) || c <= 0) {
    return { perScan: null, perParticipant: null, perSubmission: null, perUsableClip: null, perRedemption: null };
  }
  return {
    perScan: div(c, denominators.scans),
    perParticipant: div(c, denominators.participants),
    perSubmission: div(c, denominators.submissions),
    perUsableClip: div(c, denominators.usableClips),
    perRedemption: div(c, denominators.redemptions),
  };
}
